import {
  Autocomplete,
  Box,
  CircularProgress,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import CustomPagination from "../CustomPagination";
import { GET_BROKER_PROJECT_TABLE } from "../../../constants/ApiRoute";
import { authHeader } from "../../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../../comman/CustomFunction";
import API from "../../comman/API";
import sortupdownarrowIcon from "../../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../../images/sort_down_arrow.svg";
import NoRecordFound from "../../comman/NoRecordFound";

export default function BrokerProjectTable(props) {
  const { customerTab, setCustomerTab, valueTopTap } = props;

  const [sortedData, setSorteddata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [sortConfig, setSortConfig] = useState({
    key: "Name",
    direction: "asc",
  });
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [sortClickedTime, setSortClickedTime] = useState("");

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1); // Reset to page 1 when search query changes
  };

  const getBrokerProjectDetails = async (custId) => {
    setLoading(true);
    let data = {
      userId: customerTab?.brokerId ? customerTab?.brokerId : custId,
      sort: order,
      orderBy: orderBy,
      
    };
    const config = {
      method: "GET",
      url: GET_BROKER_PROJECT_TABLE,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const uniqueData = data.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.UserID === value.UserID && t.CustID === value.CustID && t.ProjID === value.ProjID
          ))
        );
        console.log(uniqueData, 'dataaaaaaaaaaaaaaaaaaa')

        setSorteddata(uniqueData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBrokerProjectDetails(customerTab?.brokerId);
  }, [customerTab?.brokerId, order, orderBy]);

  // Apply search filter to the entire dataset
  const filteredData = useMemo(() => {
    return sortedData.filter((item) =>
      ["Name", "BillingPeriod", "MileageRate", "brokerCount"].some((field) =>
        String(item[field] || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      )
    );
  }, [sortedData, searchQuery]);

  // Implement sorting logic
  const sortedAndFilteredData = useMemo(() => {
    let sortableItems = [...filteredData];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [filteredData, sortConfig]);

  // Paginate sorted and filtered data
  const paginatedData = useMemo(() => {
    return filteredData.slice(
      (page - 1) * rowsPerPage,
      (page - 1) * rowsPerPage + rowsPerPage
    );
  }, [filteredData, page]);

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    let orderValue = isAsc ? "desc" : "asc";

    setOrder(orderValue);
    setOrderBy(property);

    if (order === "desc") {
      setOrder("");
      setOrderBy("");
    }

    if (orderBy != property) {
      setOrder("asc");
      setOrderBy(property);
    }

    setPage(1);
    setSortClickedTime(new Date().toLocaleString());

    // setSortConfig((prevState) => ({
    //   key,
    //   direction: prevState.direction === "asc" ? "desc" : "asc",
    // }));
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const handleProjectNavigate = (val, CustID) => {
    console.log('customer id get',CustID)
    if (valueTopTap == "11") {
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: val,
        brokerId: "",
        customerId:CustID,
      }));
    } else {
      setCustomerTab((prevState) => ({
        ...prevState,
        customerId: CustID,
        projectId: val,
      }));
    }
  };
console.log('cutom',customerTab)
  return (
    <div>
      <Stack
        sx={{ mb: "20px" }}
        direction={{ xs: "column", sm: "row", md: "row" }}
        alignItems={{ xs: "baseline", sm: "center", md: "center" }}
        justifyContent="space-between"
      >
        <Autocomplete
          sx={{ maxWidth: "265px", width: "100%" }}
          freeSolo
          id="free-solo-2-demo"
          disableClearable
          startAdornment={
            <InputAdornment position="start">
              <span className="material-symbols-outlined">search</span>
            </InputAdornment>
          }
          options={[]}
          onInputChange={handleSearchChange}
          renderInput={(params) => (
            <TextField
              placeholder="Search"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Stack>
      <TableContainer sx={{ boxShadow: "none" }} component={Paper}>
        <Table
          // sx={{ minWidth: 650 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Name"}
                  direction={orderBy === "Name" ? order : "asc"}
                  onClick={() => handleSort("Name")}
                  IconComponent={() => getSortIcon("Name")}
                  style={orderBy === "Name" ? { color: "#007fff" } : {}}
                >
                  Projects
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "brokerCount"}
                  direction={orderBy === "brokerCount" ? order : "asc"}
                  onClick={() => handleSort("brokerCount")}
                  IconComponent={() => getSortIcon("brokerCount")}
                  style={orderBy === "brokerCount" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "brokerCount"}
                  // direction={
                  //   sortConfig.key === "brokerCount"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("brokerCount")}
                >
                  No of Brokers
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "MileageRate"}
                  direction={orderBy === "MileageRate" ? order : "asc"}
                  onClick={() => handleSort("MileageRate")}
                  IconComponent={() => getSortIcon("MileageRate")}
                  style={orderBy === "MileageRate" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "MileageRate"}
                  // direction={
                  //   sortConfig.key === "MileageRate"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("MileageRate")}
                >
                  Mileage Rate
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "BillingPeriod"}
                  direction={orderBy === "BillingPeriod" ? order : "asc"}
                  onClick={() => handleSort("BillingPeriod")}
                  IconComponent={() => getSortIcon("BillingPeriod")}
                  style={
                    orderBy === "BillingPeriod" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "BillingPeriod"}
                  // direction={
                  //   sortConfig.key === "BillingPeriod"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("BillingPeriod")}
                >
                  Billing Period
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Active"}
                  direction={orderBy === "Active" ? order : "asc"}
                  onClick={() => handleSort("Active")}
                  IconComponent={() => getSortIcon("Active")}
                  style={orderBy === "Active" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Active"}
                  // direction={
                  //   sortConfig.key === "Active" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Active")}
                >
                  Active
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress disableShrink />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((val, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={
                      val.ProjID
                        ? {
                            color: "#007FFF !important",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }
                        : {}
                    }
                    onClick={() =>
                      handleProjectNavigate(val.ProjID, val.CustID)
                    }
                  >
                    <span style={{ wordBreak: "break-word" }}>
                      {" "}
                      {val.Name || "-"}
                    </span>
                  </TableCell>
                  <TableCell>{val.brokerCount || "0"}</TableCell>
                  <TableCell>${val.MileageRate.toFixed(3) || "0.000"}</TableCell>
                  <TableCell>{val.BillingPeriod || "-"}</TableCell>
                  <TableCell sx={{ minWidth: "150px" }}>
                    <span
                      className={
                        val.Active === "Yes" ? "active-btn" : "inactive-btn"
                      }
                    >
                      {val.Active === "Yes" ? "Active" : "Inactive"}
                    </span>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {/* <Typography>No Record Found</Typography> */}
                  <NoRecordFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {filteredData.length > 0 && (
          <Pagination
            sx={{ mt: "13.5px", float: "right" }}
            shape="rounded"
            // hidePrevButton
            // hideNextButton
            count={Math.ceil(filteredData.length / rowsPerPage)}
            page={page}
            onChange={handlePageChange}
          />
        )}
      </TableContainer>
    </div>
  );
}
